import { Container } from './styled';
import { BiUser } from 'react-icons/bi';

export function Avatar(props) {

    const {
        name,
        width,
        height,
        borderRadius,
        fontSize,
        className
    } = props;

    return (
        <Container
            className={className}
            width={width}
            height={height}
            borderRadius={borderRadius}
            fontSize={fontSize}
        >
            {name?.match(/[a-zA-Z]/)
                ? (name?.match(/[a-zA-Z]/)[0].toUpperCase())
                : (<BiUser fontSize={fontSize} />)
            }
        </Container>
    )
}